let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9QKO7")).then(() => parcelRequire('9cRHW'));